const API_LOGIN_URL = 'https://api.unifapdigital.unifap.br/api/login';

export interface ValidationResult {
  valid: boolean;
  message: string;
}

interface ApiLoginResponse {
  message?: string;
  sucess?: boolean;
  success?: boolean;
}

export async function validateCredentials(
  login: string,
  senha: string
): Promise<ValidationResult> {
  try {
    const response = await fetch(API_LOGIN_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ login, senha }),
    });

    const data: ApiLoginResponse = await response.json().catch(() => ({}));
    const isValid =
      response.ok && data.sucess !== false && data.success !== false;

    if (isValid) {
      return {
        valid: true,
        message:
          'Excelente! Suas credenciais foram confirmadas e estão ativas nos sistemas EduRoam, Rede CAFe, etc. .',
      };
    }

    return {
      valid: false,
      message:
        data.message ??
        'Não foi possível confirmar suas credenciais. Verifique seu usuário e senha ou atualize seus dados no sistema SIG.',
    };
  } catch {
    return {
      valid: false,
      message:
        'Não foi possível conectar ao serviço de validação. Tente novamente em alguns instantes.',
    };
  }
}
